/**
 * Central quest editor dirty reconciliation: compare full editor state to the last
 * persisted snapshot (see quest-editor-dirty.ts). DOM edits bubble to roots wired here;
 * non-DOM mutations call the same reconcile hook explicitly.
 */

export const QUEST_EDITOR_DIRTY_DOM_EVENTS = ["input", "change", "compositionend"] as const;

/** Listen on editor/page roots; handlers on child controls update `quest` before the event bubbles. */
export function bindQuestEditorDirtyDomListeners(
  roots: readonly HTMLElement[],
  reconcile: () => void,
  signal: AbortSignal,
): void {
  const onEvent = () => reconcile();
  for (const root of roots) {
    for (const type of QUEST_EDITOR_DIRTY_DOM_EVENTS) {
      root.addEventListener(type, onEvent, { signal });
    }
  }
}
